const Seo = {
    defaultTitleSeo: 'InstaSorteio - Draw with Instagram comments',
    defaultDescriptionSeo: 'Conduct sweepstakes from Instagram comments. The only one that can load all the comments.',
    defaultKeywordsSeo: 'sweepstakes, raffle, instagram, perform, insta',
    defaultImageSeo: 'https://instasorteio.com/images/seo/metatag-en.png',
  };
  
  export default Seo;
  